import React from "react";

const STEPS = ["Agreement", "Payment", "Your offer"];

const CHECK = "M5 10.5l3.2 3.2L15 7";

// Display only: carriers move with the footer button and Back. It stays
// mounted across steps, so the line fills and the finished step draws its
// check as the carrier moves on.
export default function Stepper({ current, steps = STEPS }) {
  return (
    <ol
      aria-label="Progress"
      className={`m-0 grid list-none p-0 short:-mt-1 ${
        steps.length === 2 ? "grid-cols-2" : "grid-cols-3"
      }`}
    >
      {steps.map((name, i) => {
        const n = i + 1;
        const done = n < current;
        const here = n === current;
        const state = done ? "done" : here ? "here" : "next";
        return (
          <li
            key={name}
            aria-current={here ? "step" : undefined}
            className={`relative flex flex-col items-center gap-1.5 text-[13px] transition-colors duration-500 ${
              done
                ? "done text-slate-600"
                : here
                  ? "font-bold text-slate-900"
                  : "text-slate-400"
            }`}
          >
            {i > 0 && (
              <span
                aria-hidden="true"
                className="absolute right-1/2 top-[16px] h-[3px] w-[calc(100%-36px)] -translate-x-[18px] overflow-hidden rounded-full bg-slate-200"
              >
                <span
                  className={`block h-full w-full origin-left rounded-full bg-indigo-600 transition-transform duration-[600ms] ease-[cubic-bezier(0.65,0,0.35,1)] motion-reduce:transition-none ${
                    n <= current ? "scale-x-100" : "scale-x-0"
                  }`}
                />
              </span>
            )}

            <span className="relative grid h-[34px] w-[34px] place-items-center">
              {here && (
                <span
                  aria-hidden="true"
                  className="absolute inset-0 rounded-full bg-indigo-400 opacity-0 motion-safe:animate-bi-ripple"
                />
              )}
              {/* Keyed by state so its entrance replays on each change. */}
              <span
                key={state}
                aria-hidden="true"
                className={`relative grid h-[34px] w-[34px] place-items-center rounded-full font-[Barlow_Condensed] text-[17px] font-bold tabular-nums ${
                  done
                    ? "bg-indigo-600 text-white"
                    : here
                      ? "border-[2.5px] border-indigo-600 bg-white text-indigo-600 shadow-[0_4px_14px_-4px_rgba(79,70,229,0.55)] motion-safe:animate-bi-pop"
                      : "border-2 border-dashed border-slate-300 bg-white text-slate-400"
                }`}
              >
                {done ? (
                  <svg viewBox="0 0 20 20" className="h-[18px] w-[18px]">
                    <path
                      d={CHECK}
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeDasharray="16"
                      className="motion-safe:animate-bi-draw"
                    />
                  </svg>
                ) : (
                  n
                )}
              </span>
            </span>
            {name}
          </li>
        );
      })}
    </ol>
  );
}
